module.exports = __webpack_public_path__ + "img/success-icon.d56192b6.svg";